import React from 'react';

import './ConfirmDelete.scss';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmDelete = ({ onCancel, onConfirm }: Props): React.ReactElement | null => (
  <div className="confirm-delete">
    <div className="message">
      Are you sure?
    </div>

    <div className="actions">
      <button
        type="button"
        className="button"
        onClick={onCancel}
      >
        Cancel
      </button>

      <button
        type="button"
        className="button delete"
        onClick={onConfirm}
      >
        Confirm
      </button>
    </div>
  </div>
);

export default ConfirmDelete;
